var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5C10.3642 10.6018 10.2144 10.6903 10.0531 10.7636C9.53295 11 8.84585 11 7.4716 11H4.52842C3.15417 11 2.46705 11 1.94691 10.7636C1.78562 10.6903 1.63579 10.6018 1.5 10.5",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 3.23126 1 2.34689 1.5264 1.75645C1.61059 1.66202 1.70339 1.57468 1.80373 1.49543C2.43107 1 3.37071 1 5.25 1H6.75C8.6293 1 9.56895 1 10.1962 1.49543C10.2966 1.57468 10.3894 1.66202 10.4736 1.75645C11 2.34689 11 3.23126 11 5C11 6.76875 11 7.6531 10.4736 8.24355C10.3894 8.338 10.2966 8.4253 10.1962 8.50455C9.56895 9 8.6293 9 6.75 9H5.25C3.37071 9 2.43107 9 1.80373 8.50455C1.70339 8.4253 1.61059 8.338 1.5264 8.24355C1 7.6531 1 6.76875 1 5Z",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25059 5H9.24609",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75058 5H2.74609",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2754 5C7.2754 5.69035 6.71575 6.25 6.0254 6.25C5.33505 6.25 4.77539 5.69035 4.77539 5C4.77539 4.30964 5.33505 3.75 6.0254 3.75C6.71575 3.75 7.2754 4.30964 7.2754 5Z",
    stroke: "#3F3F3F",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivePayment);
export default __webpack_public_path__ + "static/media/receive-payment.b157ec9a09af98d68e5d3e2bbd6cee11.svg";
export { ForwardRef as ReactComponent };